import { useEffect, useState } from "react";
import { PlayerContext } from "./PlayerContext";
import useData from "../hooks/useData";
import { getRadioPlaylistToday } from "../actions";

const PlayerProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentSongIndex, setCurrentSongIndex] = useState(0);
  const [secondToPlay, setSecondToPlay] = useState(0);
  const [playlist, setPlaylist] = useState([]);
  const [isMuted, setIsMuted] = useState(true);
  const [volumeLevel, setVolumeLevel] = useState(80);
  const [currentPlaylist, setCurrentPlaylist] = useState([])
  const [totalDuration, setTotalDuration] = useState(0)

  const [previousSongIndex, setPreviousSongIndex] = useState(0);
  const [nextSongIndex, setNextSongIndex] = useState(0);

  const { data: radioPlaylist } = useData(["/radio-playlists"], getRadioPlaylistToday);
 
  useEffect(() => {
     if (radioPlaylist?.data?.radio_recursos) {
       const playlistWithHeadlines = radioPlaylist.data.radio_recursos.map((item) => {
         if (!item.radio_headlines || item.radio_headlines.length === 0) {
           return {
             ...item,
             radio_headlines: [
               { text: "Bienvenido a Alta-Voz Radio - La mejor música latina", time: 0 },
             ],
           }
         }
         return item
       })
       
       setCurrentPlaylist(playlistWithHeadlines)
       setTotalDuration(radioPlaylist.data.duration || 0)
     }
   }, [radioPlaylist])
   useEffect(() => {
            if (currentPlaylist && currentPlaylist.length > 0) {
                setPlaylist(currentPlaylist);
            }
        }, [currentPlaylist]);

  const addMusic = (newMusic) => {
    setPlaylist(newMusic);
  };
  const handleOpen = () => {
        if(isMuted){
          setIsMuted(false)
        }
        setOpen(!open);
    };

  return (
    <PlayerContext.Provider 
      value={{ 
        playlist,
        addMusic, 
        open, 
        setOpen,
        isPlaying,
        setIsPlaying,
        currentSongIndex,
        setCurrentSongIndex,
        setPlaylist,
        currentPlaylist,
        setSecondToPlay,
        totalDuration,
        secondToPlay,
        setIsMuted,
        isMuted,
        setVolumeLevel,
        volumeLevel,
        handleOpen,
        previousSongIndex,
        nextSongIndex,
        setPreviousSongIndex,
        setNextSongIndex,
      }}
    >
      {children}
    </PlayerContext.Provider>
  );
};

export default PlayerProvider;